/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ReassignBidder$Params {
  'X-API-Version'?: string;
      body?: {
'bidderId': number;
'userId': number;
'makeBidderPrimary': boolean;
}
}

export function reassignBidder(http: HttpClient, rootUrl: string, params?: ReassignBidder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, reassignBidder.PATH, 'post');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

reassignBidder.PATH = '/api/admin/bidders/reassign';
